import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { t } from 'ttag';
import { useLoadingPage } from './useLoadingPage';
import './loadingPage.scss';

const ADDED_TAG_LOADING_TYPE = {
  'Signing in...': t`Signing in...`,
  'Saving event...': t`Saving event...`,
  'Saving PDF report...': t`Saving PDF report...`,
  'Saving report...': t`Saving report...`,
  'Appending study log...': t`Appending study log...`,
  'Closing event...': t`Closing event...`,
  'Generating event report...': t`Generating event report...`,
  'Generating notification report...`': t`Generating notification report...`,
  'Generating summary report...': t`Generating summary report...`,
  'Creating new study...': t`Creating new study...`,
  'Uploading report...': t`Uploading report...`,
  'Loading...': t`Loading...`,
  'Downloading...': t`Downloading...`,
  'Signing out...': t`Signing out...`,
  'Submitting...': t`Submitting...`,
  'Saving...': t`Saving...`,
  'Copying study...': t`Copying study...`,
  'Re-Generating report...': t`Re-Generating report...`,
  'Marking report...': t`Marking report...`,
  'Unmarking report...': t`Unmarking report...`,
  'Viewing ECG...': t`Viewing ECG...`,
};

/**
 * Resolves the translated label for a loading type. Looks the raw value up in the ADDED_TAG_LOADING_TYPE message map and falls back to the value itself when no translation is registered.
 *
 * @param loadingType - Raw loading type value to translate.
 * @returns The translated label, or the original value when untranslated.
 */
const gettextLoadingType = (loadingType: any) =>
  (ADDED_TAG_LOADING_TYPE as any)[loadingType] || loadingType;

interface IProps {
  /** Loading text to display, or falsy to render nothing. Supplied by the caller (e.g. read from a global store). */
  loadingText?: string;
}

/**
 * Full-page blocking spinner shown while a global operation runs. Renders nothing unless the loadingText prop is set, then shows an Ant Design Spin with a blue LoadingOutlined indicator above the text translated by gettextLoadingType.
 *
 * @param props - The loading text to display.
 * @returns The loading overlay element, or a falsy value when nothing is loading.
 */
const LoadingPage = (props: IProps) => {
  const { loadingText } = useLoadingPage(props.loadingText);

  return (
    !!loadingText && (
      <div className="loading-page-background">
        <div className="loading-page-container">
          <Spin
            indicator={
              <LoadingOutlined
                spin
                style={{
                  fontSize: 24,
                  color: '#2265c6',
                }}
              />
            }
          />
          <div className="loading-page__text">{gettextLoadingType(loadingText)}</div>
        </div>
      </div>
    )
  );
};

export default LoadingPage;
